module.exports = __webpack_public_path__ + "static/img/8-3.b9bc823.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/8-3.png
// module id = lq6O
// module chunks = 0